
(function () {

// Get all of the swipers on the page
    const allSliders = document.querySelectorAll('.u-swiper');

// Loop over all of the fetched sliders and apply Swiper on each one.
    allSliders.forEach(swiperElement => {

        const sliderId = swiperElement.dataset.id;
        swiperElement.classList.add(`swiper${sliderId}`)

        const swiper = new Swiper(`.swiper${sliderId}`, {

            allowTouchMove: false,
            slidesPerView: 1,
            navigation: {
                nextEl: `.slides-arrows__right-${sliderId}`,
                prevEl: `.slides-arrows__left-${sliderId}`
            },
            pagination: {
                el: `.swiper-scrollbar-${sliderId}`,
                clickable: 'true'
            },
        })

    });

    if (window.innerWidth < 1024) {
        new Swiper(document.querySelector(".land-slider__swiper__shorts"), {
            allowTouchMove: true,
            loop: !0,
            pagination: {
                el: ".swiper-pagination01",
                clickable: true,
            },
            slidesPerView: 1,
            spaceBetween: 80,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 30
                },
                1400: {
                    slidesPerView: 3,
                    spaceBetweenSlides: 42
                }
            },

            navigation: {
                nextEl: ".land-slider__swiper__shorts-arr-right",
                prevEl: ".land-slider__swiper__shorts-arr-left"
            },
        });
    }

    let shorts = {
        'iframe-video-1': 'https://www.youtube.com/embed/N3R6ClDRL9w',
        'iframe-video-2': 'https://www.youtube.com/embed/oc3HGg7wzpM',
        'iframe-video-3': 'https://www.youtube.com/embed/8BU7lw3Mq20',
        'iframe-video-4': 'https://www.youtube.com/embed/CvM3VXE0QBc',
        'iframe-video-5': 'https://www.youtube.com/embed/qcxqgR9Lf3Q',
        'iframe-video-6': 'https://www.youtube.com/embed/IjKofIYNIC0',
        'iframe-video-7': 'https://www.youtube.com/embed/K1HZ_I_CBLA',
        'iframe-video-8': "https://player02.getcourse.ru/sign-player/?json=eyJ2aWRlb19oYXNoIjoiZGJhNDgwNDhlYmI5NTRlN2I5ODM4ZDI4NjQ4NjZhYzciLCJ1c2VyX2lkIjoyODExNjEzMjEsInN1Yl9sb2dpbl91c2VyX2lkIjpudWxsLCJsZXNzb25faWQiOm51bGwsImlwIjoiMjEzLjEzNS43Mi4yMCIsImdjX2hvc3QiOiJvbmxpbmUuc29zdGF2LnNjaG9vbCIsInRpbWUiOjE3MjYyMjE4NTgsInBheWxvYWQiOiJ1XzI4MTE2MTMyMSIsInVpX2xhbmd1YWdlIjoicnUiLCJ1c2VyX3JvbGUiOiJhZG1pbiJ9&amp;s=a10c3d9ceb7b477a45cec06e9bc14b92&amp;vh-static-feature=zigzag",
        'iframe-video-9': 'https://www.youtube.com/embed/i-lSWXnTGaQ',
        'iframe-video-10': 'https://www.youtube.com/embed/rTT_QTnsNVs',
    }
    let shorts2 = {
        'repina': '/static/landings/_defaults/vid/repina.mp4',
        'lazuchenkov': '/static/landings/_defaults/vid/lazuchenkov.mp4',
        'redko': '/static/landings/_defaults/vid/redko.mp4',
        'simon': '/static/landings/_defaults/vid/simon.mp4',
        'pitilimov': '/static/landings/_defaults/vid/pitilimov.mp4',
        'popov': '/static/landings/_defaults/vid/popov.mp4',
        'kirin': '/static/landings/_defaults/vid/kirin.mp4',
        'semchuk': '/static/landings/_defaults/vid/semchuk.MOV',
        'oleg': '/static/landings/_defaults/vid/oleg.MOV',
        'vdovichenko-shorts':  '/static/landings/_defaults/vid/vdovichenko-shorts.mp4',
        'pomerantsev':  '/static/landings/_defaults/vid/pomerantsev.mp4',
        'petenko':  '/static/landings/_defaults/vid/short-petenko.mp4',
        'chtchyan':  '/static/landings/_defaults/vid/short-chtchyan.mp4',
        'reputaciya':  '/static/landings/reputaciya/INTRO_V.mp4',
    }



    if (document.querySelector('.shorts')) {
        document.querySelectorAll('.shorts').forEach(el =>
        el.addEventListener('click', function (e) {
            if (e.target.classList.contains('swiper-slide')) {
                const videoId = e.target.getAttribute('id');
                for (const key in shorts) {
                    if (videoId === key) {

                        var src = shorts[key];
                        if (key !== 'iframe-video-8') {
                            src += `?controls='0'&autoplay=1`
                        }

                        const iframe = document.createElement('div');
                        iframe.innerHTML = `
                        <iframe 
                            class="iframe-video" 
                            src="${src}" 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            allowfullscreen>
                            
                        </iframe>
                        <button class="iframe-close">&times;</button>
                        <div class="overlay"></div>`;
                        iframe.classList.add('iframe-video-wrap');

                        document.querySelector('.app__content').appendChild(iframe)

                    }
                }
                for (const key in shorts2) {
                    if (videoId === key) {
                        var addedClass;
                        if (key === 'vdovichenko-shorts' || key === 'semchuk' || key === 'petenko' || key === 'chtchyan' || key === 'reputaciya') {
                            addedClass = 'diff-height'
                        }
                        const iframe = document.createElement('div');
                        iframe.innerHTML = `<video 
                                    class="iframe-video  ${addedClass}"  
                                    width = '250'  height = '475' controls
                                    autoplay="autoplay"> 
                                        <source src="${shorts2[key]}" type="video/mp4">
                                    </video>
                            <button class="iframe-close">&times;</button>
                            <div class="overlay"></div>`;

                        iframe.classList.add('iframe-video-wrap');

                        document.querySelector('.app__content').appendChild(iframe)


                    }
                }
                document.querySelector('.overlay')
                    ? document.querySelector('.overlay').addEventListener('click', function () {
                        document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                    }) : window.console.log(iframe);
                document.querySelector('.iframe-close').addEventListener('click', function () {
                    document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                })
            }
        }))

    }


    var dropdowns = document.querySelectorAll('.dropdown');

    dropdowns.forEach(function(elem) {
        elem.addEventListener('click', switchTextBlockVisibility)
    });

    function switchTextBlockVisibility(e) {
        debugger
        var chosenBl = e.target.closest('.dropdown');
        var isOpenedClicked = chosenBl.classList.contains('opened');
        window.console.log(isOpenedClicked);
        if (!isOpenedClicked) {
            chosenBl.classList.add('opened');
        } else {
            chosenBl.classList.remove('opened');
        }
    }
    if (document.querySelector('.show-uroks__btn')) {
        document.querySelector('.show-uroks__btn').addEventListener('click', function(e) {
            var parent = e.target.closest('.part-urok');
            var line = document.querySelector('.uroks-line');
            if (parent.classList.contains('full')) {
                parent.querySelector('.show-uroks__text').innerText = 'Свернуть';
                parent.querySelector('.show-uroks__btn').style.transform = 'rotate(180deg)';
                line.style.visibility = 'hidden';
                document.querySelector('.added-uroks').style.height = 'initial';
                document.querySelector('.added-uroks').style.opacity = '1';
                document.querySelector('.added-uroks').style.transition = 'all .4s ease';
                parent.classList.remove('full');
            } else {
                parent.querySelector('.show-uroks__text').innerText = 'Вся программа\n';
                parent.querySelector('.show-uroks__btn').style.transform = 'rotate(0deg)';
                line.style.visibility = 'visible';
                document.querySelector('.added-uroks').style.height = '0';
                document.querySelector('.added-uroks').style.opacity = '0';
                document.querySelector('.added-uroks').style.transition = 'all .4s ease';
                parent.classList.add('full');
            }



            // e.target.closest('.show-uroks').style.display = 'none';
/*            window.console.log('11');
            e.target.closest('.show-uroks').querySelector('.show-uroks__btn').style.transform = 'rotate(180deg)';


                document.querySelector('.uroks-line').style.display = 'none';

            document.querySelector('.added-uroks').style.height = 'initial';
            document.querySelector('.added-uroks').style.opacity = '1';
            document.querySelector('.added-uroks').style.transition = 'all .4s ease';*/
        })
    }

    if (document.querySelector('.reviews-item__more')) {
        var reviews = document.querySelectorAll('.reviews-item__more');
        reviews.forEach(function(elem) {
            elem.addEventListener('click', function(e) {
                var parent = e.target.closest('.reviews-item');
                var hiddenText = parent.querySelector('.reviews-item__end')
                var dots = parent.querySelector('.reviews-item__dots');
                if (elem.classList.contains('full')) {
                    dots.style.display = 'none';
                    elem.innerHTML = "Свернуть";
                    hiddenText.style.height = 'initial';
                    hiddenText.style.display = 'initial';
                    hiddenText.style.opacity = '1';
                    hiddenText.style.transition = 'all .4s ease';
                    elem.classList.toggle("full");

                } else {
                    elem.innerHTML = "Читать полностью";
                    dots.style.display = 'inline';
                    hiddenText.style.height = '0';
                    hiddenText.style.display = 'none';
                    hiddenText.style.opacity = '0';
                    hiddenText.style.transition = 'all .4s ease';
                    elem.classList.toggle("full");
                }

                e.target.closest('.reviews-item__more').style.display = 'none';
                hiddenText.style.height = 'initial';
                hiddenText.style.display = 'initial';
                hiddenText.style.opacity = '1';
                hiddenText.style.transition = 'all .4s ease';
            })
        });
    }
    if (document.querySelector('.reviews-item__less')) {
        var reviews = document.querySelectorAll('.reviews-item__less');

        reviews.forEach(function(elem) {
            elem.addEventListener('click', function(e) {
                var parent = e.target.closest('.reviews-item');
                var hiddenText = parent.querySelector('.reviews-item__end')
                var dots = parent.querySelector('.reviews-item__dots');
                parent.querySelector('.reviews-item__less').style.display = 'block';
                dots.style.display = 'inline-block';
                e.target.closest('.reviews-item__more').style.display = 'block';
                hiddenText.style.height = '0';
                hiddenText.style.display = 'none';
                hiddenText.style.opacity = '0';
                hiddenText.style.transition = 'all .4s ease';
            })
        });
    }




    document.querySelector('.app').addEventListener('click', function (e) {
        let menu = document.querySelector('.hburger-menu');
        let burgerIcon = e.target.closest('.burger-icon');
        let innerMenu = e.target.closest('.hburger-document.cookiemenu');
        let btnClose = e.target.closest('.hburger-menu-close');
        if (burgerIcon) {
            menu.classList.contains('hidden') ? menu.classList.remove('hidden') : menu.classList.add('hidden')
        } else if (innerMenu) {
            if (btnClose) {
                menu.classList.add('hidden')
            }
        } else {
            menu.classList.add('hidden')
        }
    })

})()


